import { Box, useTheme } from '@mui/material';
import { ErrorIcon } from '@synergy/theme-next';
import { PropsWithChildren, ReactNode, forwardRef } from 'react';
import { SnackbarContent } from 'notistack';

import { SnackbarCard } from './snackbar-card';

export interface ErrorSnackbarProps extends PropsWithChildren {
    message: ReactNode;
}

export const ErrorSnackbar = forwardRef<HTMLDivElement, ErrorSnackbarProps>((props, ref) => {
    const theme = useTheme();

    return (
        <SnackbarContent ref={ref}>
            <SnackbarCard
                cardColor={theme.palette.error.main}
                textColor={theme.palette.error.contrastText}
                hasActions={!!props.children}
            >
                <ErrorIcon />
                {props.message}
                {props.children && <Box sx={{ ml: 'auto' }}>{props.children}</Box>}
            </SnackbarCard>
        </SnackbarContent>
    );
});
